import { Box, CircularProgress } from '@mui/material';
import React from 'react';

const LoadingOverlay = ({
    loading,
    size = 60,
    color = 'primary',
    message,
    blurIntensity = 1,
}) => {
    if (!loading) return null;

    return (
        <Box
            sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,     
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000,
                backdropFilter: 'blur(4px)',
            }}
        >
            <CircularProgress size={size} />
        </Box>
    );
};

export default LoadingOverlay;
